import httpClient from 'utils/httpClient';
import { withPortalScope } from 'utils/portalScope';

const path = '/dashboard';

export const getSummary = (params = {}) => {
  return httpClient.get(`${path}/summary`, { params: withPortalScope(params) });
};

export const getReceiveslipChart = (params = {}) => {
  return httpClient.get(`${path}/chart/receiveslip`, { params: withPortalScope(params) });
};


export const getListAnnounceDashboard = () => {
  return httpClient.get(`${path}/announce`);
};

export const getListNews = () => {
  return httpClient.get(`${path}/news`);
};

export const getListMail = () => {
  return httpClient.get(`${path}/mail`);
};

export const getListStock = (params = {}) => {
  return httpClient.get(`${path}/stock`, { params: withPortalScope(params) });
};


export const getDebit = (params = {}) => {
  return httpClient.get(`${path}/debit`, { params: withPortalScope(params) });
};

export const getFinancialOverview = (params = {}, { signal } = {}) =>
  httpClient.get(`${path}/financial-overview`, { params: withPortalScope(params), signal });

export const getFinancialAnalysis = (params = {}, { signal } = {}) =>
  httpClient.get(`${path}/financial-analysis`, { params: withPortalScope(params), signal });

export const getOperationalDashboard = (domain, params = {}, { signal } = {}) =>
  httpClient.get(`${path}/${domain}`, { params: withPortalScope(params), signal });
